var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Other / Hot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Other-/-Hot",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fire-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23 L11.9999997,23 C16.1421397,23 19.4999997,19.64214 19.4999997,15.5 C19.4999997,14.634 19.2699997,13.803 18.9999997,13.03 C17.3329997,14.677 16.0669997,15.5 15.1999997,15.5 C19.1949997,8.5 16.9999997,5.5 10.9999997,1.5 C11.4999997,6.5 8.20399967,8.774 6.86199967,10.037 L6.86199939,10.0370003 C3.84486939,12.8749903 3.69964939,17.6215103 6.53764139,20.6386003 C7.95489139,22.1453003 9.93149139,22.9997803 12.0000014,23 L12,23 Z M12.71,5.23499987 C15.951,7.985 15.967,10.122 13.463,14.509 C12.702,15.842 13.665,17.5 15.2,17.5 C15.888,17.5 16.584,17.3 17.319,16.905 L17.319,16.9049999 C16.541658,19.8414199 13.53106,21.5916899 10.59464,20.8143499 C7.65822003,20.0370079 5.90795003,17.0264099 6.68529003,14.0899899 C6.94819603,13.0968599 7.48400203,12.1972199 8.23200003,11.4929999 C8.35800003,11.3749999 8.99700003,10.8079999 9.02500003,10.7829999 C9.44900003,10.4029999 9.79800003,10.0659999 10.143,9.69699987 C11.373,8.37899987 12.257,6.91699987 12.709,5.23499987 L12.71,5.23499987 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/Hot.a5a00f80af2cea94e315189150bafad6.svg";
export { ForwardRef as ReactComponent };